/** Earth 与 SpaceMouse 表面支点拾取的默认 near 偏移，单位为世界坐标。 */
export const DEFAULT_NATIVE_CONTROL_SURFACE_PICK_NEAR_OFFSET = 0.1

/** Earth 与 SpaceMouse 表面拾取窗口的默认像素尺寸。 */
export const DEFAULT_NATIVE_CONTROL_SURFACE_PICK_WINDOW_SIZE = 129

/** Earth 与 SpaceMouse 缩放的默认绝对最小步长，单位为世界坐标。 */
export const DEFAULT_NATIVE_CONTROL_MIN_ZOOM_STEP = 0.3

/** Earth 与 SpaceMouse 原生控制器的表面拾取配置。 */
export interface NativeControlSurfacePickingOptions {
  /** 从活动相机 near 平面继续向前偏移的世界坐标距离，默认 0.1。 */
  readonly nearOffset?: number
}

/** 解析原生控制器表面拾取窗口，确保使用正奇数像素尺寸。 */
export function resolveNativeControlPickWindowSize(
  value: number | undefined,
  fieldName: string
): number {
  const resolved = value ?? DEFAULT_NATIVE_CONTROL_SURFACE_PICK_WINDOW_SIZE
  if (
    !Number.isFinite(resolved) ||
    !Number.isInteger(resolved) ||
    resolved < 1 ||
    resolved % 2 === 0
  ) {
    throw new RangeError(`${fieldName} 必须是大于等于 1 的奇数`)
  }
  return resolved
}

/** 解析原生控制器缩放绝对最小步长。 */
export function resolveNativeControlMinZoomStep(
  value: number | undefined,
  fieldName: string
): number {
  const resolved = value ?? DEFAULT_NATIVE_CONTROL_MIN_ZOOM_STEP
  if (!Number.isFinite(resolved) || resolved < 0) {
    throw new RangeError(`${fieldName} 必须是有限且不小于零的数`)
  }
  return resolved
}
